import { DatePivotParams } from "../../entities/date_pivot_params";
import dayjs from "../../utils/dayjs";

export const defaultConfig: DatePivotParams = {
  dateHierarchy: "order_placed_month",
  measure: "quantity",
  segments: ["channel"],
  minDate: dayjs.utc().startOf("year").toDate(),
  maxDate: dayjs.utc().add(1, "year").startOf("year").toDate(),
  filters: [],
};
